const taipeiClock = new Intl.DateTimeFormat("en-GB", {
  timeZone: "Asia/Taipei",
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
  weekday: "short",
  hour: "2-digit",
  minute: "2-digit",
  hourCycle: "h23",
});

const collectionDays = new Set(["Mon", "Tue", "Thu", "Fri", "Sat"]);
const REMINDER_MINUTE = 14 * 60 + 15;
const DEPARTURE_MINUTE = 14 * 60 + 30;

// 垃圾車 14:30 離開：只在 14:15 觸發，14:30 起不再顯示或補提醒。
export function getTrashReminderSchedule(now = new Date()) {
  const parts = Object.fromEntries(
    taipeiClock.formatToParts(now).map(({ type, value }) => [type, value])
  );
  const minutes = Number(parts.hour) * 60 + Number(parts.minute);
  if (!collectionDays.has(parts.weekday) || minutes < REMINDER_MINUTE || minutes >= DEPARTURE_MINUTE) return null;
  return {
    day: `${parts.year}-${parts.month}-${parts.day}`,
    shouldStart: minutes === REMINDER_MINUTE,
  };
}
